import axiosClient from "./axiosClient";

const bannerApi = {
    getAll() {
        return axiosClient.get("banner");
    },
    create(formData: FormData) {
        return axiosClient.post("banner", formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    update(id: number, formData: FormData) {
        return axiosClient.put(`banner/${id}`, formData, {
            headers: { "Content-Type": "multipart/form-data" },
        });
    },
    toggle(id: number) {
        return axiosClient.patch(`banner/${id}/toggle`);
    },
    delete(id: number) {
        return axiosClient.delete(`banner/${id}`);
    },
};

export default bannerApi;
